import { Component, OnInit, ElementRef, OnDestroy } from "@angular/core";
import { ROUTES } from "../sidebarMain/sidebar.component";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: "navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"]
})
export class NavbarComponent implements OnInit, OnDestroy {
  titlePageHebrew: string = "חניונים אוטונומיים | שקמה ידע וטכנולוגיה בע&quot;מ | חולון";
  titlePageEnglish: string = "Shikma N&T";
  languages = LANGUAGES;
	selectedLanguage;
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;

  public isCollapsed = true;

  closeResult: string;

  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private titleService: Title) {
      this.location = location;
      this.sidebarVisible = false;
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
   updateColor = () => {
   var navbar = document.getElementsByClassName('navbar')[0];
     if (window.innerWidth < 993 && !this.isCollapsed) {
       navbar.classList.add('bg-white');
       navbar.classList.remove('navbar-transparent');
     } else {
       navbar.classList.remove('bg-white');
       navbar.classList.add('navbar-transparent');
     }
   };

  ngOnInit() {
    window.addEventListener("resize", this.updateColor);
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
    this.router.events.subscribe(event => {
      this.sidebarClose();
      var $layer: any = document.getElementsByClassName("close-layer")[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
    this.selectedLanguage = this.languages.find((language) => language.code === this.translateService.currentLang);	
    this.translateService.use(this.selectedLanguage.code);
    this.selectLanguage(this.selectedLanguage);
  }

  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName("nav")[0];
    if (!this.isCollapsed) {
      navbar.classList.remove("navbar-transparent");
      navbar.classList.add("bg-white");
    } else {
      navbar.classList.add("navbar-transparent");
      navbar.classList.remove("bg-white");
    }
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    const html = document.getElementsByTagName("html")[0];
    if (window.innerWidth < 991) {
      mainPanel.style.position = "fixed";
    }

    setTimeout(function() {
      toggleButton.classList.add("toggled");
    }, 500);

    html.classList.add("nav-open");

    this.sidebarVisible = true;
  }
  
  sidebarClose() {
    const html = document.getElementsByTagName("html")[0];
    this.toggleButton.classList.remove("toggled");
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );

    if (window.innerWidth < 991) {
      setTimeout(function() {
        mainPanel.style.position = "";
      }, 500);
    }
    this.sidebarVisible = false;
    html.classList.remove("nav-open");
  }

  sidebarToggle() {
    var $toggle = document.getElementsByClassName("navbar-toggler")[0];

    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const html = document.getElementsByTagName("html")[0];

    if (this.mobile_menu_visible == 1) {

      html.classList.remove("nav-open");
      if ($layer) {
        $layer.remove();
      }
      setTimeout(function() {
        $toggle.classList.remove("toggled");
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(function() {
        $toggle.classList.add("toggled");
      }, 430);

      var $layer = document.createElement("div");
      $layer.setAttribute("class", "close-layer");

      if (html.querySelectorAll(".main-panel")) {
        document.getElementsByClassName("main-panel")[0].appendChild($layer);
      } else if (html.classList.contains("off-canvas-sidebar")) {
        document
          .getElementsByClassName("wrapper-full-page")[0]
          .appendChild($layer);
      }

      setTimeout(function() {
        $layer.classList.add("visible");
      }, 100);

      $layer.onclick = function() {
        //asign a function
        html.classList.remove("nav-open");
        this.mobile_menu_visible = 0;
        $layer.classList.remove("visible");
        setTimeout(function() {
          $layer.remove();
          $toggle.classList.remove("toggled");
        }, 400);
      }.bind(this);

      html.classList.add("nav-open");
      this.mobile_menu_visible = 1;
    }
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return "Dashboard";
  }

  selectLanguage(language: Language) {
		this.selectedLanguage = language;
    this.translateService.use(language.code);
    
    if(language.flagCode === "il"){
      this.setTitle(this.titlePageHebrew);
      var navbar = document.getElementsByClassName('navbar')[0];
      var navbarNav = document.getElementsByClassName('navbar-nav');
      var dropdownMenu = document.getElementsByClassName('dropdown-menu');

      for (let i = 0; i < navbarNav.length; i++) {
        navbarNav[i].setAttribute("style", "margin-right: auto;")
      }

      for (let i = 0; i < dropdownMenu.length; i++) {
        dropdownMenu[i].setAttribute("style", "right: auto !important; left: 0 !important;")
      }

      window.addEventListener("resize", this.updateColor);
      this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
      this.router.events.subscribe(event => {
        this.sidebarClose();
        var $layer: any = document.getElementsByClassName("close-layer")[0];
        if ($layer) {
          $layer.remove();
          this.mobile_menu_visible = 0;
        }
      });
      // on this page, we need on the body tag the classes .rtl and .menu-on-right
      document.body.classList.add("rtl", "menu-on-right");
      // we also need the rtl bootstrap
      // so we add it dynamically to the head
      let rtlIdElement = document.getElementById("rtl-id");
      if(!rtlIdElement){
        let head = document.head;
        let link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.id = "rtl-id";
        link.href =
          "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css";
        head.appendChild(link);
      }
    }else{
      this.setTitle(this.titlePageEnglish);
      var navbarNav = document.getElementsByClassName('navbar-nav');
      var dropdownMenu = document.getElementsByClassName('dropdown-menu');

      for (let i = 0; i < dropdownMenu.length; i++) {
        dropdownMenu[i].setAttribute("style", "right: 0 !important; left:auto !important;")
      }
      for (let i = 0; i < navbarNav.length; i++) {
        navbarNav[i].setAttribute("style", "margin-left: auto;");
      }
      // when we exit this page, we need to delete the classes .rtl and .menu-on-right
      // from the body tag
      let rtlIdElement = document.getElementById("rtl-id");
      if(rtlIdElement) {
        document.body.classList.remove("rtl", "menu-on-right");
        // we also need to delete the rtl bootstrap, so it does not break the other pages
        // that do not make use of rtl
        document.getElementById("rtl-id").remove();
      }
    }
  }

  open(content) {
    this.modalService.open(content, {windowClass: 'modal-search'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
  ngOnDestroy(){
     window.removeEventListener("resize", this.updateColor);
  }

	logout() {
		this.authenticationService.logout();
	}

  setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
 
}

export interface Language {
	flagCode: string;
	code: string;
	fullName: string;
}

export const LANGUAGES: Language[] = [
	{
		flagCode: 'us',
		code: 'en',
		fullName: 'English'
	},
	{
		flagCode: 'il',
		code: 'il',
		fullName: 'Hebrew' 
	}
];
